import { RadioGroup } from "@headlessui/react";
import { useWarrantyData } from "app/hooks";
import { useWarrantyOrderVoucherData } from "app/hooks/payment/useWarrantyOrderVoucherData";
import { useOrderContext } from "app/providers/OrderProvider";
import { usePaymentContext } from "pages/payment/providers/PaymentProvider";
import { Dispatch, Fragment, SetStateAction, useEffect, useMemo } from "react";
import { WarrantyPackage } from "shared/api/middleware-api-client";
import { voucherState } from "shared/store/voucher/voucherStore";
import Icon, { IconTypes } from "shared/ui/icon";
import Radio, { RadioVariant } from "shared/ui/radio";
import { concatClassnames } from "shared/utils/concatClassnames";
import { useSnapshot } from "valtio";

interface WarrantyPackageListProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedWarrantyPackageForModal: Dispatch<
    SetStateAction<WarrantyPackage | undefined>
  >;
}

const PaymentWarrantyList: React.FC<WarrantyPackageListProps> = ({
  setIsModalOpen,
  isModalOpen,
  setSelectedWarrantyPackageForModal,
}) => {
  const { warranties: fetchedWarrantyPackages } = useWarrantyData();
  const { warrantyPackages } = usePaymentContext();
  const { warrantyPackage, setWarrantyPackage } = useOrderContext();

  const { voucher } = useSnapshot(voucherState);
  const voucherWarranties = voucher?.warrantyPackages;

  const { voucherWarrantyPackage } = useWarrantyOrderVoucherData({
    warrantyPackages,
    voucherWarranties,
  });

  useEffect(() => {
    if (voucherWarrantyPackage) {
      setWarrantyPackage(voucherWarrantyPackage);
    }
  }, [setWarrantyPackage, voucher, voucherWarrantyPackage]);

  return (
    <>
      {warrantyPackage ? (
        <RadioGroup
          value={warrantyPackage}
          onChange={setWarrantyPackage}
          className={concatClassnames("gg-grid gg-gap-y-2")}
          disabled={!!voucherWarrantyPackage}
        >
          {warrantyPackages.map((pkg, i) => {
            const packageName = pkg.packageId?.toString().toLowerCase();
            return (
              <RadioGroup.Option
                key={`warranty-${pkg.packageId}`}
                value={pkg}
                as={Fragment}
              >
                <div className="gg-flex gg-items-center gg-gap-x-1">
                  <Radio
                    variant={RadioVariant.CIRCLE}
                    id={packageName}
                    onChange={() => {}}
                    checked={pkg.packageId === warrantyPackage.packageId}
                    className={"gg-shrink-0"}
                  />

                  <label
                    htmlFor={packageName}
                    className={concatClassnames("gg-align-middle")}
                  >
                    {pkg.name}
                    {pkg.packageId !==
                      fetchedWarrantyPackages.decideLaterWarrantyPackage
                        .packageId &&
                      pkg.packageId !==
                        fetchedWarrantyPackages.noWarrantyPayNowPackage
                          .packageId && (
                        <button
                          className="gg-absolute gg-ml-1 gg-inline-block"
                          onClick={(e) => {
                            setSelectedWarrantyPackageForModal(pkg);
                            setIsModalOpen(!isModalOpen);
                          }}
                        >
                          <Icon name={IconTypes.INFO} className="gg-h-5"></Icon>
                        </button>
                      )}
                  </label>
                </div>
              </RadioGroup.Option>
            );
          })}
        </RadioGroup>
      ) : (
        <></>
      )}
    </>
  );
};
export default PaymentWarrantyList;
